import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Making an Editor for Your DSL",
description: "Create editor projections in Freon—including defaults, list layouts, inherited projections, and triggers—to make your DSL readable and easy to edit.",
tags: [ "Freon", "editor", "projections", "projectional editing", "DSL", "Topic", "Page", "Theory", "Video", "WorkSheet", "ExamplePage", "InDepthMaterial", "Question", "Line", "Fraction", "SimpleNumber", "lists", "separator", "initiator", "terminator", "triggers", "inheritance", "Education language", "tutorial"] ,
modifiedTime: "2025-11-07T17:20:18.626Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};